/* unplugin-vue-components disabled */import { render } from "./kpiNamePopover.vue?vue&type=template&id=1b9737cd&scoped=true"
import script from "./kpiNamePopover.vue?vue&type=script&lang=js"
export * from "./kpiNamePopover.vue?vue&type=script&lang=js"

import "./kpiNamePopover.vue?vue&type=style&index=0&id=1b9737cd&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9737cd"]])

export default __exports__